import { auth, db } from "../services/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

export const authDiagnostic = {
    // Verificar estado actual de autenticación
    async checkAuthState() {
        return new Promise((resolve) => {
            const unsubscribe = onAuthStateChanged(auth, async (user) => {
                if (user) {
                    // Verificar si existe documento en Firestore
                    try {
                        const userDoc = await getDoc(doc(db, "users", user.uid));
                        
                        if (userDoc.exists()) {
                            // Usuario existe en Firestore
                            // Puede agregar lógica adicional aquí si es necesario
                        } else {
                            // Usuario no existe en Firestore
                            // Puede agregar lógica para crear el documento aquí si es necesario
                        }
                    } catch (error) {
                        // Error al verificar documento de usuario
                        // Puede agregar manejo de errores aquí si es necesario
                    }
                } else {
                    // No hay usuario autenticado
                    // Puede agregar lógica adicional aquí si es necesario
                }
                
                unsubscribe();
                resolve(user);
            });
        });
    },
    
    // Verificar configuración de Firebase
    checkFirebaseConfig() {
        // Verificar que auth y db estén configurados correctamente
        if (!auth || !db) {
            throw new Error("Firebase no está configurado correctamente");
        }
        return true;
    },
    
    // Crear documento de usuario manualmente
    async createUserDocument(userId, userData) {
        try {
            await setDoc(doc(db, "users", userId), {
                email: userData.email,
                displayName: userData.displayName,
                status: "pending_kyc",
                profileCompleted: false,
                createdAt: new Date().toISOString(),
                isAdmin: false,
                role: "user",
                balance: 0,
                lastLogin: new Date().toISOString()
            });
            
            return true;
        } catch (error) {
            return false;
        }
    },
    
    // Verificar reglas de Firestore
    async testFirestoreAccess(userId) {
        try {
            // Intentar leer documento
            await getDoc(doc(db, "users", userId));
            
            // Intentar escribir documento (solo para testing)
            await setDoc(doc(db, "test_access", "test"), {
                test: true,
                timestamp: new Date().toISOString()
            });
            
            return true;
        } catch (error) {
            return false;
        }
    }
};

// Función para ejecutar diagnóstico completo
export const runAuthDiagnostic = async () => {
    // Verificar configuración
    authDiagnostic.checkFirebaseConfig();
    
    // Verificar estado de autenticación
    const user = await authDiagnostic.checkAuthState();
    
    if (user) {
        // Verificar acceso a Firestore
        await authDiagnostic.testFirestoreAccess(user.uid);
    }
    
    return user;
}; 